import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const CatalystInsightWrapper = styled.div<{
  $isClickable: boolean;
}>`
  width: fit-content;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  ${borderRadius.r2};
  background: var(--icon-gold-3);
  ${({ $isClickable }) =>
    $isClickable &&
    css`
      &:hover {
        cursor: pointer;
      }
    `}
`;

export const CatalystInsightLabel = styled.span`
  ${typographyV2.uiXs};
  font-family: var(--font-nort);
  color: var(--chart-gold);
`;
